module.exports = __webpack_public_path__ + "static/img/maisui1.e693f2df.png";